<template>
<div class="CreateServiceSkeleton">
  <div class="d-flex align-center">
    <div class=" w-100">
      <v-skeleton-loader
        v-bind="attrs"
        width="100%"
        max-width="564"
        min-height="44"
        type="text"
      />
    </div>
    <div class="w-100">
      <v-skeleton-loader
        v-bind="attrs"
        width="100%"
        max-width="60"
        type="actions"
      />
    </div>

  </div>
  <div class="d-flex flex-column">
    <div class="d-flex w-100 align-center mb-4">
      <div class=" w-100">
        <v-skeleton-loader
          v-bind="attrs"
          width="100%"
          max-width="564"
          min-height="44"
          type="text"
        />
      </div>
      <div class="w-100">
        <v-skeleton-loader
          v-bind="attrs"
          width="100%"
          max-width="60"
          type="actions"
        />
      </div>
    </div>
    <div class="d-flex">
      <v-skeleton-loader
        v-bind="attrs"
        width="100%"
        max-width="205"
        type="button"
      />
      <v-skeleton-loader
        v-bind="attrs"
        width="100%"
        max-width="205"
        type="button"
      />
    </div>

  </div>

</div>
</template>

<script>
/**
 * Компонент: CreateServiceSkeleton
 * Описание:
 */
export default {
  name: 'CreateServiceSkeleton',

  components: {},

  props: {},

  data() {
    return {
      attrs: {
        class: '',
        elevation: 0,
        boilerplate: false,
      },
    };
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.CreateServiceSkeleton {
  width: 100%;
  display: flex;
  gap: 28px;
  flex-direction: column;
  ::v-deep.v-skeleton-loader__text{
    width: 100%;
    height: 44px;
    margin: 0;
  }
  ::v-deep.v-skeleton-loader__actions{
    background: none!important;
    padding: 0;
    height: 100%;
    & .v-skeleton-loader__button{
      height: 24px;
      width: 24px;
      border-radius: 100%;
    }
  }
  /* Стили компонента */
}
</style>
